import { Announcement } from '@/modules/announcement/models/Announcement';
import { unseenAnnouncements } from '@/modules/announcement/store/announcement.state';

export function getUnseenAnnouncements(): Announcement[] {
  return unseenAnnouncements.value ?? [];
}
